import { Component, OnInit, OnDestroy } from '@angular/core';
import numeral from 'numeral';
import { AppState } from './app.reducer';
import { Store } from '@ngrx/store';
import { EncoderService } from './services/encoder.service';
import { AuthService } from './auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { OrderStatusCheckerService } from './services/order-status-checker.service';
import { CartProductValidatorService } from './services/cart-product-validator.service';
import { SetIdiomaAction } from './shared/reducers/ui.accions';
import { IOrder, Order } from './shared/models/order.model';
import { SetOrderActions } from './shared/reducers/order.actions';
import { environment } from 'src/environments/environment';
import daysjs from 'dayjs';
import 'dayjs/locale/es';
import { SetAddressActions } from './shared/reducers/address.actions';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {

	constructor(
		public authService: AuthService,
		private encoder: EncoderService,
		private translate: TranslateService,
		// private sectionService: SectionsService,
		// private textReports: TextsReportsService,
		private _encoder: EncoderService,
		private _router: Router,
		private store: Store<AppState>,
		private orderStatusChecker: OrderStatusCheckerService,
		private cartProductValidator: CartProductValidatorService) {
		numeral.register('locale', 'es', {
			delimiters: {
				thousands: '.',
				decimal: ','
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: (num: number) => {
				return num === 1 ? 'er' : 'ème';
			},
			currency: {
				symbol: '€'
			}
		});
		numeral.locale('es');
	}


	ngOnInit() {
		daysjs.locale('es');

		const order = localStorage.getItem('order');
		const address = localStorage.getItem('address');
		if (address) {
			this.store.dispatch(new SetAddressActions(JSON.parse(this._encoder.decode(address))));
		}
		this.authService.initAuthListener();
		this.translate.setDefaultLang('es');
		this.store.dispatch(new SetIdiomaAction('es'));

		const orderObject: IOrder = (order) ? JSON.parse(this._encoder.decode(order)) : new Order();
		this.store.dispatch(new SetOrderActions(orderObject));

		this.orderStatusChecker.startOrderStatusCheck();

		this.cartProductValidator.startCartValidation();

	}



	ngOnDestroy(): void {
		this.orderStatusChecker.stopOrderStatusCheck();
		this.cartProductValidator.stopCartValidation();
	}
}
